import React, { useState, useEffect } from 'react';

import styles from '../raports/raports.module.scss';

import { Space } from '../../components/utils/utils';
import { buildMonitorizationMessage, prettyDate } from '../../utils/strings';

import { Skeleton } from 'antd';
import CCollapseInstitution from '../../components/collapse/collapse-institution';

import { getInstitutionsMonitorizations } from '../../network/monitorization';
import CCard from '../../components/card/card';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../routing/routes';

const AdministrateMonitorizations = () => {
  //   const [filterValue, setValue] = useState('');
  const [data, setData] = useState([] as any[]);

  const getRaports = async () => {
    getInstitutionsMonitorizations().then(({ data }) => setData(data.data));
  };

  //   const handleFilter = (event: React.ChangeEvent<any>) => {
  //     const { value } = event.target;
  //     setValue(value);
  //   };

  //   const handleSort = (key: string) => {
  //     setSort(key);
  //   };

  //   //   useEffect(() => {
  //     const direction = sortValue === 'up' ? 1 : -1;
  //     const sorted = sort_chronologically(raports.data, 'createdAt', direction);

  //     setRaports({ ...raports, data: sorted });
  //     // eslint-disable-next-line
  //   }, [sortValue]);

  //   useEffect(() => {
  //     getRaports(currentPage);
  //   }, [currentPage]);

  //   useEffect(() => {
  //     const filtered =
  //       initial_raports &&
  //       initial_raports.data &&
  //       initial_raports.data.filter(
  //         (entry: IRaport) =>
  //           entry.createdAt
  //             .toString()
  //             .slice(0, 10)
  //             .toLowerCase()
  //             .includes(filterValue) ||
  //           prettyDate(entry.createdAt).toLowerCase().includes(filterValue)
  //       );

  //     setRaports({ ...raports, data: filtered });
  //     // eslint-disable-next-line
  //   }, [filterValue, initial_raports]);

  useEffect(() => {
    getRaports();
  }, []);

  return (
    <div className={styles.container}>
      {data && (
        <>
          <div className={styles.rowInfo}>
            <div className='column align-start '>
              <p className='subheading-dark bold'>Administrare monitorizari</p>
              <p className='body-dark'>
                {`Aveti ${data.length} ${
                  data.length === 1 ? 'instituție' : 'instituții'
                } ${data.length === 1 ? 'subordonată' : 'subordonate'}.`}
              </p>
            </div>
          </div>
          <div className={styles.content}>
            <div className='justify-start'>
              {/* <CSearchBar value={filterValue} onChange={handleFilter} /> */}
              <Space horizontal={20} />
              {/* <CSorting value={filterValue} onChange={handleSort} /> */}
            </div>

            {data && (
              <div className={styles.list}>
                {data &&
                  data.length > 0 &&
                  data.map((entry: any) => (
                    <CCollapseInstitution
                      //   key={entry.institution.id}
                      //   id={entry.institution.id}
                      title={
                        <div className='column fullWidth'>
                          <p className='subheading-dark fullWidth bold'>{`Instituția 
                            ${entry.name}`}</p>
                          <p className='body-dark thin'>
                            Această instituție a introdus{' '}
                            {entry.decisionResumes &&
                              entry.decisionResumes.length}{' '}
                            {entry.decisionResumes &&
                            entry.decisionResumes.length === 1
                              ? 'monitorizare'
                              : 'monitorizări'}
                            .
                          </p>
                        </div>
                      }
                      details={'Vezi monitorizări'}
                      institution={{ id: entry.id, name: entry.name }}
                    >
                      {entry.decisionResumes.length === 0 && (
                        <p className='body-dark faded'>
                          Aceasta institutie nu a introdus nicio monitorizare.
                        </p>
                      )}
                      {entry.decisionResumes &&
                        entry.decisionResumes.map((monitorization: any) => (
                          <CCard
                            title={`Monitorizare creată pe ${prettyDate(
                              monitorization.createdAt
                            )}`}
                            key={monitorization.id}
                            description={buildMonitorizationMessage(
                              monitorization.type,
                              monitorization.fileCount,
                              monitorization.measureCount,
                              monitorization.expiredMeasureCount,
                              monitorization.expiredMeasureCountToday
                            )}
                            details={
                              <Link
                                to={{
                                  pathname: `${ROUTES.DECISION}`,
                                  state: {
                                    id: monitorization.id,
                                    editingMode: false
                                  }
                                }}
                              >
                                Detalii
                              </Link>
                            }
                          />
                        ))}
                    </CCollapseInstitution>
                  ))}
              </div>
            )}
          </div>
          <Space vertical='1vh' />
        </>
      )}
      {!data && <Skeleton />}
    </div>
  );
};

export default AdministrateMonitorizations;
